// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V22H22V2ZM4 8V4H5.53163L8.86496 8H4ZM11.4684 8L8.13504 4H12.5316L15.865 8H11.4684ZM18.4684 8L15.135 4H20V8H18.4684ZM9 14V12H15V14H9Z"}}]};

const MovieClapperFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'movie-clapper-filled',
    ref,
    icon: element,
  },
));

MovieClapperFilledIcon.displayName = 'MovieClapperFilledIcon';

export default MovieClapperFilledIcon;
